/* Luova.fi product page: variant ladder, gallery, quote / stock-notification panel.
   The add-to-cart itself is Dawn's product-form.js. Everything here enhances markup that
   already works without JavaScript (radios named "id", a plain contact form). */
(() => {
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const MODE_KEY = 'luova-request-mode';

  function init(root) {
    if (root.dataset.luovaReady) return;
    root.dataset.luovaReady = 'true';

    const gallery = root.querySelector('[data-luova-gallery]');
    const request = root.querySelector('.luova-request');
    const panel = root.querySelector('[data-luova-request-panel]');
    const email = root.querySelector('[data-luova-request-email]');
    const submit = root.querySelector('[data-luova-request-submit]');
    const toggles = root.querySelectorAll('[data-luova-panel-toggle]');
    let mode = 'quote';

    /* --- gallery ------------------------------------------------------------------- */
    const showMedia = (id) => {
      if (!gallery || !id) return;
      const slide = gallery.querySelector(`[data-media-id="${id}"]`);
      if (!slide) return;
      gallery.querySelectorAll('[data-media-id]').forEach((s) => (s.hidden = s !== slide));
      gallery.querySelectorAll('[data-luova-thumb]').forEach((t) => {
        if (t.dataset.luovaThumb === String(id)) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    };
    if (gallery) {
      gallery.addEventListener('click', (e) => {
        const thumb = e.target.closest('[data-luova-thumb]');
        if (thumb) showMedia(thumb.dataset.luovaThumb);
      });
    }

    /* --- request panel (quote or stock notification) --------------------------------- */
    const setMode = (next) => {
      mode = next;
      if (!request) return;
      request.querySelectorAll('[data-mode-text]').forEach((el) => (el.hidden = el.dataset.modeText !== mode));
      request.querySelectorAll('[data-mode-only]').forEach((el) => (el.hidden = el.dataset.modeOnly !== mode));
      const type = request.querySelector('[data-luova-request-type]');
      const title = request.querySelector(`.luova-request__title[data-mode-text="${mode}"]`);
      if (type && title) type.value = title.textContent.trim();
    };

    const openPanel = (next, focus = true) => {
      if (!panel) return;
      setMode(next);
      panel.hidden = false;
      toggles.forEach((t) => t.setAttribute('aria-expanded', String(t.dataset.luovaPanelToggle === next)));
      if (focus && email) email.focus();
    };

    const closePanel = () => {
      if (!panel) return;
      panel.hidden = true;
      toggles.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    };

    toggles.forEach((btn) =>
      btn.addEventListener('click', () => {
        const next = btn.dataset.luovaPanelToggle;
        if (!panel.hidden && mode === next) closePanel();
        else openPanel(next);
      })
    );

    const validate = () => {
      if (submit && email) submit.disabled = !EMAIL.test(email.value.trim());
    };
    if (email) {
      email.addEventListener('input', validate);
      validate();
    }
    if (request) {
      request.addEventListener('submit', () => {
        try { sessionStorage.setItem(MODE_KEY, mode); } catch (e) {}
      });
    }

    /* After a successful post Shopify reloads the page; show the matching confirmation. */
    const done = root.querySelector('[data-luova-request-done]');
    if (done) {
      let sent = 'quote';
      try { sent = sessionStorage.getItem(MODE_KEY) || 'quote'; sessionStorage.removeItem(MODE_KEY); } catch (e) {}
      done.querySelectorAll('[data-done-mode]').forEach((el) => (el.hidden = el.dataset.doneMode !== sent));
      done.scrollIntoView({ block: 'center' });
    }

    /* Cards link to #quote on quote-only products. */
    if (location.hash === '#quote' && root.dataset.state === 'quote') openPanel('quote', false);

    /* --- long book texts fold behind "Lue lisää" ----------------------------------------- */
    root.querySelectorAll('[data-luova-fold]').forEach((body) => {
      const toggle = body.parentElement.querySelector('[data-luova-fold-toggle]');
      if (!toggle) return;
      body.classList.add('is-folded');
      /* Stop at the last paragraph that fits whole, so no line is cut in half. */
      const limit = body.clientHeight;
      let cut = 0;
      [...body.children].forEach((child) => {
        const bottom = child.offsetTop - body.offsetTop + child.offsetHeight;
        if (bottom <= limit) cut = bottom;
      });
      if (cut > 0) {
        body.dataset.foldHeight = `${cut}px`;
        body.style.maxHeight = body.dataset.foldHeight;
      }
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        const folded = body.classList.toggle('is-folded');
        body.style.maxHeight = folded ? body.dataset.foldHeight || '' : '';
        toggle.setAttribute('aria-expanded', String(!folded));
        toggle.textContent = folded ? toggle.dataset.labelMore : toggle.dataset.labelLess;
        if (folded) body.scrollIntoView({ block: 'nearest' });
      });
    });

    /* --- variant ladder -------------------------------------------------------------- */
    root.addEventListener('change', (e) => {
      const input = e.target.closest('[data-luova-variant]');
      if (!input) return;
      const id = input.value;
      const state = input.dataset.state;

      root.dataset.state = state;
      root.querySelectorAll('[data-luova-variant-panel]').forEach((p) => (p.hidden = p.dataset.luovaVariantPanel !== id));

      const skuLabel = root.querySelector('[data-luova-sku]');
      if (skuLabel) skuLabel.textContent = input.dataset.sku ? `${skuLabel.dataset.prefix} ${input.dataset.sku}` : '';
      const specSku = root.querySelector('[data-luova-spec-sku]');
      if (specSku) specSku.textContent = input.dataset.sku || '—';

      /* Gift cards: Dawn's recipient form matches cart errors to the chosen variant. */
      const recipient = root.querySelector('recipient-form');
      if (recipient) recipient.currentProductVariantId = id;

      const variantField = root.querySelector('[data-luova-request-variant]');
      if (variantField) variantField.value = input.dataset.title;
      const label = root.querySelector('[data-luova-request-product]');
      if (label) label.textContent = `${label.dataset.productTitle} · ${input.dataset.title}`;
      const urlField = root.querySelector('[data-luova-request-url]');

      if (input.dataset.mediaId) showMedia(input.dataset.mediaId);

      /* Board packs: a single sheet ("1 kpl") is pickup only, the full pack goes by freight. */
      const single = /^1\s/.test(input.dataset.title || '');
      root.querySelectorAll('[data-luova-ship-line]').forEach((line) => {
        line.hidden = line.dataset.luovaShipLine !== (single ? 'single' : 'pack');
      });

      /* The open panel only makes sense for its own state. */
      if (panel && !panel.hidden && !((state === 'quote' && mode === 'quote') || (state === 'soldout' && mode === 'notify'))) {
        closePanel();
      }

      const url = new URL(location.href);
      url.searchParams.set('variant', id);
      history.replaceState(history.state, '', url);
      if (urlField) urlField.value = url.origin + url.pathname + '?variant=' + id;
    });
  }

  const start = () => document.querySelectorAll('[data-luova-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
